
import Vue from 'vue'
import JcdcExportWrapper from '@/components/jcdc/JcdcExportWrapper.vue'
import JcdcFullscreenDialog from '@/components/jcdc/JcdcFullscreenDialog.vue'
export default Vue.extend({
  name: 'JcdcExportPrintReport',
  components: {
    JcdcExportWrapper,
    JcdcFullscreenDialog,
  },
  props: {
    align: { type: String, default: 'left' },
    secondary: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    btnText: { type: String, default: 'View Report' },
    // File Name
    appTitle: { type: String, required: true },
    title: { type: String, required: true },
    tabTitle: { type: String, default: 'Report' },
    searchList: { type: Array as () => string[], default: (): [] => [] },
    filterList: { type: Array as () => string[], default: (): [] => [] },
    infoDate: { type: [String, Date, Number, Object], default: null },
  },
  data() {
    return {
      dialog: false,
      fileName: '',
    }
  },
  methods: {
    printPage() {
      const tempTitle = document.title
      document.title = this.fileName
      // fixes print
      const element = document.getElementsByClassName('v-application--wrap')[0]
      element.classList.add('d-none')
      setTimeout(() => {
        window.print()
        document.title = tempTitle
        element.classList.remove('d-none')
      }, 300)
    },
  },
})
